<!--
 * @Author: pengyong
 * @Date: 2020-11-12 20:50:59
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-08 21:56:45
 * @Description: 个人中心
 * @FilePath: /exhibit/src/views/user/index.vue
-->
<template>
    <div class="user-wrapper">
        <div class="user-container">
            <div class="backHome" @click="backHome">
                <img :src="require('@/assets/user/close.png')" alt="" />
            </div>
            <div class="sidebar" v-if="!hideUserModalSideBar">
                <div class="user-info">
                    <img :src="require('@/assets/user/avatar.png')" alt="" class="avatar" />
                    <p class="user-name" v-if="userInfo.real_name">{{ userInfo.real_name || "" }}</p>
                </div>
                <p class="phone">{{ $t("userCenter").account }}：{{ userInfo.phone || userInfo.email || "" }}</p>
                <div class="menu-wrapper">
                    <div to="/exhibition/user" @click="changeChildId(0)" :class="['menu-item', 'menu-item-card', showChildId === 0 && 'active-menu']">
                        <img :src="require('@/assets/user/myCard.png')" alt="" />
                        {{ $t("userCenter").cardTitle }}
                    </div>
                    <div class="menu">
                        <div class="menu-item">
                            <img :src="menuCollects.icon" alt="" />
                            {{ menuCollects.name }}
                        </div>
                        <div
                            :class="['menu-item-child', showChildId === list.id && 'active-menu']"
                            v-for="list in menuCollects.subMenus"
                            :key="list.name"
                            :to="list.path"
                            @click="changeChildId(list.id)"
                        >
                            {{ list.name }}
                        </div>
                    </div>
                    <div @click="changeChildId(4)" :class="['menu-item', 'single-menu', showChildId === 4 && 'active-menu']">
                        <img :src="require('@/assets/user/card.png')" alt="" />
                        {{ $t("userCenter").card }}
                    </div>
                    <div class="menu">
                        <div class="menu-item">
                            <img :src="menuAccounts.icon" alt="" />
                            {{ menuAccounts.name }}
                        </div>
                        <div
                            :class="['menu-item-child', showChildId === list.id && 'active-menu']"
                            v-for="list in menuAccounts.subMenus"
                            :key="list.name"
                            :to="list.path"
                            @click="changeChildId(list.id)"
                        >
                            {{ list.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <BusinessCard v-if="showChildId === 0" />
                <VideoCollect v-if="showChildId === 1" />
                <ExhibitsCollect v-if="showChildId === 2" />
                <FileCollect v-if="showChildId === 3" />
                <CardList v-if="showChildId === 4" />
                <UserInfo v-if="showChildId === 5" />
                <AmendPassword v-if="showChildId === 6" />
                <ExhibitorsCollect v-if="showChildId === 7" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BusinessCard from "@/views/user/businessCard";
import VideoCollect from "@/views/user/videoCollect";
import ExhibitsCollect from "@/views/user/exhibitsCollect";
import FileCollect from "@/views/user/fileCollect";
import CardList from "@/views/user/cardList";
import UserInfo from "@/views/user/userInfo";
import AmendPassword from "@/views/user/amendPassword";
import ExhibitorsCollect from "@/views/user/exhibitorsCollect"

export default {
    components: {
        BusinessCard,
        VideoCollect,
        ExhibitsCollect,
        FileCollect,
        CardList,
        UserInfo,
        AmendPassword,
        ExhibitorsCollect
    },
    computed: {
        ...mapState(["userInfo", "hideUserModalSideBar", "showChildId"]),
        showCollapse() {
            return [this.$t("userCenter").collect, this.$t("userCenter").accountInfo];
        },
        menuCollects() {
            return {
                name: this.$t("userCenter").collect,
                icon: require("@/assets/user/collect.png"),
                subMenus: [
                    {
                        name: this.$t("userCenter").collectVideo,
                        path: "/exhibition/user/videoCollect",
                        id: 1
                    },
                    {
                        name: this.$t("userCenter").collectZp,
                        path: "/exhibition/user/exhibitsCollect",
                        id: 2
                    },
                    {
                        name: this.$t("userCenter").collectFile,
                        path: "/exhibition/user/fileCollect",
                        id: 3
                    },
                    {
                        name: this.$t("userCenter").collectExhibitors,
                        path: "/exhibition/user/exhibitorsCollect",
                        id: 7
                    }
                ]
            };
        },
        menuAccounts() {
            return {
                name: this.$t("userCenter").accountInfo,
                icon: require("@/assets/user/accountInfo.png"),
                subMenus: [
                    {
                        name: this.$t("userCenter").baseInfo,
                        path: "/exhibition/user/userInfo",
                        id: 5
                    },
                    {
                        name: this.$t("userCenter").modifyPsw,
                        path: "/exhibition/user/amendPassword",
                        id: 6
                    }
                ]
            };
        }
    },
    methods: {
        changeChildId(id) {
            this.$store.commit("setState", {
                showChildId: id
            });
        },
        backHome() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";

.user-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    box-shadow: 0px 5px 7px 3px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    z-index: $zIndex-user-wrapper;
    width: 50%;
    height: 74.44%;
    min-width: 650px;
    min-height: 536px;
    overflow: hidden;
    .user-container {
        display: flex;
        height: 100%;
    }
    .backHome {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
        > img {
            width: 100%;
            height: 100%;
        }
    }
    .sidebar {
        padding: 37px 0 0 31px;
        display: inline-block;
        vertical-align: middle;
        cursor: default;
        flex-shrink: 0;
        width: 180px;
        height: 100%;
        overflow-y: auto;
        box-sizing: content-box;
        .user-info {
            display: flex;
            align-items: center;
            .avatar {
                width: 37px;
                height: 37px;
                margin-right: 11px;
                border-radius: 50%;
            }
            .user-name {
                font-size: 16px;
                font-weight: 600;
                color: #09468c;
            }
        }
        .phone {
            height: 14px;
            line-height: 14px;
            font-size: 9px;
            font-weight: 500;
            color: #09468c;
            margin-top: 11px;
            opacity: 0.45;
            margin-bottom: 45px;
        }
        .menu-wrapper {
            padding: 23px 10px;
            background: #f4f4f4;
            font-size: 14px;
            border-radius: 18px;
            // margin-bottom: 111px;
            .menu-item {
                display: flex;
                align-items: center;
                opacity: 0.45;
                color: #09468c;
                margin-bottom: 13px;
                font-weight: 500;
                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 6px;
                }
            }
            .menu-item-child {
                margin-bottom: 13px;
                padding-left: 32px;
                opacity: 0.45;
                color: #09468c;
                &:last-of-type {
                    margin-bottom: 0;
                }
            }
            .active-menu {
                opacity: 1;
                font-weight: 500;
            }
            .single-menu {
                margin-top: 13px;
            }
        }
    }
    .container {
        display: inline-block;
        vertical-align: middle;
        height: 100%;
        flex: 1;
        overflow-y: auto;
        padding-left: 31px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/index.vue